//API serivice FUNCTIONS
import moment from "moment";
import { setDataForChart, checkLineStatus, getFromLocalStorage, insertLineStatus, loadComponent, setToLocalStorage, unLoadComponent } from "../../Helpers/helpers";
import { success } from "../../Helpers/notification";
import { setAlerts, setMergeList, setMergeStat, setStatsList } from "../../Redux/features/kpis.slice";
import { changeShiftDate, setCurrentPlant, setPlantsList, changeShift, updateList, changeKey, updateShifts } from "../../Redux/features/plant.slice";
import { setComponentLoader, setPageLoader } from "../../Redux/features/utils.slice";
import { getRequest, postRequest } from "../apiMethods";
import { apiRoutes } from "../apiRoutes"
const { kpis } = apiRoutes;

const getMergeFullDay = async (dispatch, current) => {
    dispatch(setPageLoader({ page: 'dashboard', flag: true }))
    let { plant = null, line = null, shiftDate = new Date() } = current;
    let response = await postRequest({
        endPoint: kpis.stats,
        body: { "conditions": { "_id": `${line?.id}-merged-${moment(shiftDate).format('YYYY-MM-DD')}`,
        "lineId": line?.id,
        "plantId": plant?._id}}
            // `{%22_id%22:%22${line?.id}-merged-${moment(shiftDate).format('YYYY-MM-DD')}%22,%22lineId%22:%22${line?.id}%22,%22plantId%22:%22${plant?._id}%22}`
    })
    console.log(response, 'mergefullday response')
    if (!response?.success || !Array.isArray(response?.response) || !response?.response?.length) {
        setToLocalStorage([], 'stats')
        dispatch(setMergeStat({ stat: [], chartMachines: [], currentChart: undefined }))
        dispatch(setPageLoader({ page: 'dashboard', flag: false }))
        return
    }
    let chartMachines = getChartMachines(response?.response[0]?.oee?.[0])
    setToLocalStorage(response?.response[0], 'stats')
    dispatch(setMergeStat({
        stat: response?.response[0],
        chartMachines,
        currentChart: Object.keys(response?.response[0]?.oee?.[0] || {})[0]?.replace('_Machine', '')
    }))
    dispatch(setPageLoader({ page: 'dashboard', flag: false }))
}

const updateChartData = async (payload, dispatch, kpis, stats) => {
    let machineName = findMachine(payload)
    loadComponent(dispatch, 'chart')
    // console.log({ stats, payload, machineName })
    let updatedStats = await statUpdater(stats, payload, machineName)
    // console.log({ updatedStats })
    setToLocalStorage(updatedStats, 'stats')
    let chartMachines = getChartMachines(stats?.oee[0])
    dispatch(setMergeStat({
        stat: updatedStats,
        chartMachines,
        currentChart: machineName
    }))
    setTimeout(() => unLoadComponent(dispatch, 'chart'), 1000);
}

const getMergeShiftWise = async (dispatch, current) => { 
    dispatch(setPageLoader({ page: 'oee_dashboard', flag: true }))
    let { plant = null, line = null, shift = null, shiftDate = new Date(), machine = null } = current;
    let response = await postRequest({
        endPoint: kpis.stats,
        body: { 
        "conditions":  {
            "_id": `${line?.id}-${shift?.range}-${moment(shiftDate).format('YYYY-MM-DD')}`,
            "lineId": line?.id,
            "plantId": plant?._id}
    }
            // `{%22_id%22:%22${shift?.statsId}%22,%22lineId%22:%22${line?.id}%22,%22plantId%22:%22${plant?._id}%22}`
    })
    if (!response?.success || !Array.isArray(response?.response)) {
        setToLocalStorage({}, 'stats')
        dispatch(setMergeStat({ stat: {} }))
        dispatch(setPageLoader({ page: 'oee_dashboard', flag: false }))
        return
    }
    setToLocalStorage(response?.response?.length ? response?.response[0] : {}, 'stats')
    // Preparing OEE Array for Charts
    let downtimes = response?.response[0]?.downtimeLog?.length ? response?.response[0]?.downtimeLog : []
    let disconnects = response?.response[0]?.disconnectLog?.length ? response?.response[0]?.disconnectLog : []

    let oee = response
        ?.response[0]
        ?.oee
    oee = setDataForChart(response
        ?.response[0], plant?.timezone);
    // ?.slice(0, 10)
    oee = oee?.map(data => (
        {
            ...data,
            targetOEE: line?.targetOee || machine?.targetOee || 0,
            maxOEE: 100,
            lineStatus: checkLineStatus(data, downtimes, disconnects, current)
        }))

    const idealRunRate = 1 / (shift && shift?.product ? 60 / shift?.product?.lineSpeed : 1);
    let idealOutput =
        response?.response[0]?.stats?.idealOutput ||
        Math.round(response?.response[0]?.productionTime * idealRunRate)
    dispatch(setMergeStat({
        stat: response?.response?.length ? { ...response?.response[0], oee, idealOutput } : {},
    }))
    dispatch(setPageLoader({ page: 'oee_dashboard', flag: false }))
}

const getMergeList = async (dispatch, current) => {
    let { plant = null, line = null, shift = null,machine = null } = current;
    let machineName = machine && machine.machineName!='default'?machine.machineName:null
    machineName = machineName?`%22${machineName}%22`:null
    let response = await postRequest({
        endPoint: kpis.mergeList,
        body: { "conditions": {
            "shift.fromTime":{"$gte": "2023-01-02T19:00:00.000Z", "$lt": "2023-01-03T18:59:59.999Z"},"plantId": plant?._id,"lineId": line?.id,"machine": machineName }, "attributes": {"_id":1,"shift":1} }
            // `{%22shift.fromTime%22:{%22$gte%22:%222023-01-02T19:00:00.000Z%22,%22$lte%22:%222023-01-03T18:59:59.999Z%22},%22plantId%22:%22${plant?._id}%22,%22lineId%22:%22${line?.id}%22,%22machine%22:${machineName}}&attributes={%22_id%22:1,%22shift%22:1}`
    })
    dispatch(setMergeList({
        mergeList: (response?.success && Array.isArray(response?.response)) ? response.response : []
    }))
}

const getShifts = async (dispatch, current, selectedDate = null) => {

    dispatch(setPageLoader({ page: 'oee_dashboard', flag: true }))
    let { plant = null, line = null, shift = null, machine = null, shiftDate = new Date() } = current;

    shiftDate = selectedDate || shiftDate;
    let machineName = machine && machine.machineName!='default'?machine.machineName:null
    //machineName = machineName?`%22${machineName}%22`:null
    /* If Selected Date is Current Date */
    if (moment(shiftDate).format('DD/MM/YYYY') === moment().format('DD/MM/YYYY')) {
        let shiftsArr = machine?.shifts ? machine?.shifts : line?.shifts
        let updatedShifts = shiftsArr
            ?.map((shift) => (
                {
                    ...shift,
                    statsId:machineName?`${line?.id}-${machineName}-${shift?.range}-${moment(shiftDate).format('YYYY-MM-DD')}`: `${line?.id}-${shift?.range}-${moment(shiftDate).format('YYYY-MM-DD')}`
                }))
        dispatch(updateShifts(updatedShifts))
        dispatch(setPageLoader({ page: 'oee_dashboard', flag: false }))
        return
    }

    /* Else */
    let gteValue = moment(shiftDate)
        .startOf('day')
        .toDate();

    let lteValue = moment(shiftDate)
        .endOf('day')
        .toDate()

    machineName = machineName? machineName :null
    let response = await postRequest({
        endPoint: kpis.list, 
        body: { "conditions": {
            "shift.fromTime":{"$gte": gteValue, "$lte": lteValue},"plantId": plant?._id,"lineId": line?.id,"machine": machineName }, "attributes": {"_id":1,"shift":1} }})
            // `{%22shift.fromTime%22:{%22$gte%22:%22${gteValue}%22,%22$lte%22:%22${lteValue}%22},%22plantId%22:%22${plant?._id}%22,%22lineId%22:%22${line?.id}%22,%22machine%22:${machineName}}&attributes={%22_id%22:1,%22shift%22:1}`
    console.log('response stats list', response?.response)


    
        if (!response?.success || !Array.isArray(response?.response) || !response?.response?.length) {
        dispatch(setPageLoader({ page: 'oee_dashboard', flag: false }))
        return
    }

    let shifts = (response?.response?.status) == 200 && response?.response?.map((data) => ({ ...data?.shift, statsId: data?._id }))
    if(!!shifts) {
    dispatch(updateShifts(shifts))
    dispatch(setPageLoader({ page: 'oee_dashboard', flag: false }))
    }

}

const getAlerts = async (dispatch, current) => {
    dispatch(setComponentLoader({ component: 'alerts', flag: true }))
    let { plant = null, line = null, shift = null, shiftDate = new Date() } = current;
    const tomorrow = new Date(shiftDate)
    tomorrow.setDate(tomorrow.getDate() + 1)
    let start = `${moment(shiftDate).format('YYYY-MM-DD')}T02:00:00.000Z`
    let end = `${moment(tomorrow).format('YYYY-MM-DD')}T01:59:00.000Z`
    let response = await postRequest({
        endPoint: kpis.alerts,
        body: { "conditions": { "time": { "$gte": start, "$lte": end }, "lineId": line?.id } }
    })
    if (response?.success && Array.isArray(response?.response) && response.response.length)
        dispatch(setAlerts(response.response))
    dispatch(setComponentLoader({ component: 'alerts', flag: false }))
}



const getChartMachines = (obj = {}) => {
    let array = []
    Object.keys(obj)
        .forEach((key) => {
            if (key !== 'time')
                array.push(key?.replace('_Machine', ''))
        })
    return array
}

const findMachine = (payload) => {
    let machines = getFromLocalStorage('machines')
    let machineName = (machines.filter((machine) => machine.machineName === payload?.machine)[0]?.displayName).replace(' ', '')
    return machineName === 'BlowMould' ? 'BlowMold' : machineName
}

const statUpdater = async (stats, payload, machineName) => {
    // console.log({ machineName, stats, payload })
    let oee = payload?.oee?.map((data, index) => (
        { ...stats?.oee[index], [`${machineName}_Machine`]: data?.value, time: data?.time }
    ))
    let updatedStats = { ...stats, oee, updated_at: payload?.updated_at }
    return updatedStats;
}

export {
    getMergeFullDay,
    getMergeShiftWise,
    getMergeList,
    getAlerts,
    updateChartData,
    getShifts,
}